import type { SmriqJourneyError } from '../hooks/useSmriqJourney';
import { isSmriqSessionExpired } from './smriqSessionExpired';
import { lastCompletedServiceFieldErrors, planControlsErrorMessage } from './lastCompletedServiceFieldErrors';

export const PLAN_CONTROLS_ERROR_FIELDS = ['duration_months', 'plan_start_date'] as const;
export type PlanControlsErrorField = (typeof PLAN_CONTROLS_ERROR_FIELDS)[number];

export const planControlsFieldMessage = (
    error: SmriqJourneyError | null,
    field: PlanControlsErrorField,
): string | undefined =>
    error?.fieldErrors?.[field]?.[0] ?? (error?.param === field ? error.message : undefined);

const CONTROLS_NOTICE_CODES: readonly string[] = [
    'rate_limit_exceeded',
    'service_plan_unavailable',
    'service_plan_not_configured',
];

const controlsOwn = (error: SmriqJourneyError): boolean =>
    isSmriqSessionExpired(error) ||
    CONTROLS_NOTICE_CODES.includes(error.code) ||
    PLAN_CONTROLS_ERROR_FIELDS.some((field) => planControlsFieldMessage(error, field));

/** The plan-outcome messages for the Service Order panel, step message first; [] when none. */
export function serviceOrderErrorMessages(
    error: SmriqJourneyError | null,
    { autoMatch, panelMounted }: { autoMatch: boolean; panelMounted: boolean },
): string[] {
    if (!error) return [];
    const step = panelMounted ? lastCompletedServiceFieldErrors(error, autoMatch).step : undefined;
    const outcome = controlsOwn(error) ? undefined : planControlsErrorMessage(error, panelMounted);
    return [...new Set([step, outcome].filter((message): message is string => !!message))];
}
